export const HEADER_CLASSNAME = 'js-header';
export const HEADER_HEIGHT = 54;
export const HEADER_HEIGHT_LG = 128;
